import { render, staticRenderFns } from "./ItemStatusIcons.vue?vue&type=template&id=f5dbb7fe"
import script from "./ItemStatusIcons.vue?vue&type=script&setup=true&lang=js"
export * from "./ItemStatusIcons.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports